export default __webpack_public_path__ + "static/media/data.23a378af.svg";